webpackJsonp([30,28],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(205);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(387);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(386);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueFroalaWysiwyg = __webpack_require__(244);
	
	var _vueFroalaWysiwyg2 = _interopRequireDefault(_vueFroalaWysiwyg);
	
	var _app = __webpack_require__(594);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _router = __webpack_require__(389);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueFroalaWysiwyg2.default);
	
	__webpack_require__(532);
	
	_auth2.default.init().then(function () {
	  new _vue2.default({
	    router: _router.router,
	    el: '#app',
	    render: function render(h) {
	      return h(_app2.default);
	    }
	  });
	});

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(160);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(188);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(205);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(386);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _jwtDecode = __webpack_require__(589);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var auth = new _vue2.default({
	  data: function data() {
	    return {
	      ready: false,
	      authHeader: {
	        'Authorization': null,
	        'Content-Type': 'application/json'
	      },
	      user: {
	        id: null,
	        name: null,
	        email: null,
	        permissions: {
	          accounts: 0,
	          prospects: 0,
	          website: 0,
	          employees: 0,
	          admin: 0
	        }
	      },
	      authenticated: false,
	      token: null
	    };
	  },
	  created: function created() {
	    this.token = typeof window.localStorage.getItem('token') !== 'undefined' ? window.localStorage.getItem('token') : null;
	  },
	
	  methods: {
	    init: function init() {
	      var that = this;
	      return new _promise2.default(function (resolve) {
	        if (that.ready) {
	          return resolve(that);
	        }
	
	        that.checkAuth().then(function () {
	          that.ready = true;
	          return resolve(that);
	        });
	      });
	    },
	    parseUser: function parseUser() {
	      var claims = (0, _jwtDecode2.default)(this.token);
	      (0, _assign2.default)(this.user, claims['cui']);
	    },
	    login: function login(credentials) {
	      var that = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        that.$http.post('/api/auth/login', credentials).then(function (response) {
	          if (response.data.status !== 200) {
	            return resolve(false);
	          }
	
	          that.token = response.data.data.Token;
	          window.localStorage.setItem('token', response.data.data.Token);
	          that.authenticated = true;
	          that.parseUser();
	          that.$emit('login-successful');
	          return resolve(true);
	        }, function (response) {
	          return reject(response.status);
	        });
	      });
	    },
	    logout: function logout() {
	      window.localStorage.removeItem('token');
	      this.$emit('force-logout');
	    },
	    checkAuth: function checkAuth() {
	      var that = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        if (that.token == null) {
	          return resolve(false);
	        }
	
	        that.authHeader.Authorization = 'Bearer ' + that.token;
	
	        that.$http.get('/api/auth/validate', {
	          headers: that.authHeader
	        }).then(function (response) {
	          if (response.data.status !== 200) {
	            that.authenticated = false;
	            window.localStorage.removeItem('token');
	            that.$emit('force-logout');
	            return resolve(false);
	          }
	
	          that.authenticated = true;
	          that.parseUser();
	          return resolve(true);
	        }, function (response) {
	          reject(response.status);
	        });
	      });
	    },
	    requireAuth: function requireAuth(to, _from, next) {
	      this.checkAuth().then(function (resp) {
	        if (!resp) {
	          return next({
	            path: '/login',
	            query: {
	              redirect: to.fullPath
	            }
	          });
	        }
	        return next();
	      });
	    },
	    afterAuth: function afterAuth(_to, from, next) {
	      if (this.authenticated) {
	        return next(from.path);
	      }
	
	      return next();
	    },
	    requireAdminAuth: function requireAdminAuth(to, _from, next) {
	      var that = this;
	      that.checkAuth().then(function (resp) {
	        if (!resp || that.user.admin === 0) {
	          return next({
	            path: '/accounts',
	            query: {
	              redirect: to.fullPath
	            }
	          });
	        }
	
	        return next();
	      });
	    }
	  },
	  watch: {
	    'token': {
	      handler: function handler() {
	        this.authHeader.Authorization = 'Bearer ' + this.token;
	      }
	    }
	  }
	});
	
	exports.default = auth;

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(548)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(441),
	  /* template */
	  __webpack_require__(661),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-254a5236",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = undefined;
	
	var _vueRouter = __webpack_require__(387);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var login = function login(resolve) {
	  return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var password = function password(resolve) {
	  return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(627)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var reset = function reset(resolve) {
	  return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(634)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var accounts = function accounts(resolve) {
	  return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(596)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsAdd = function accountsAdd(resolve) {
	  return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(385)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsView = function accountsView(resolve) {
	  return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(597)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewSubscriptions = function accountsViewSubscriptions(resolve) {
	  return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(604)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewSubscriptionsEdit = function accountsViewSubscriptionsEdit(resolve) {
	  return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(605)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewDevices = function accountsViewDevices(resolve) {
	  return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(600)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewStatistics = function accountsViewStatistics(resolve) {
	  return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(603)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewAgreements = function accountsViewAgreements(resolve) {
	  return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(598)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewChanges = function accountsViewChanges(resolve) {
	  return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(599)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewHistory = function accountsViewHistory(resolve) {
	  return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(601)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewSettings = function accountsViewSettings(resolve) {
	  return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(385)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var accountsViewInformation = function accountsViewInformation(resolve) {
	  return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(602)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var prospects = function prospects(resolve) {
	  return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(628)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var prospectsAdd = function prospectsAdd(resolve) {
	  return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(629)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var website = function website(resolve) {
	  return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(635)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var websiteArticleList = function websiteArticleList(resolve) {
	  return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(637)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var websiteArticle = function websiteArticle(resolve) {
	  return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(636)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var websiteContentEdit = function websiteContentEdit(resolve) {
	  return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(638)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var websiteLanguageFile = function websiteLanguageFile(resolve) {
	  return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(639)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var websiteLogoSort = function websiteLogoSort(resolve) {
	  return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(640)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var libraries = function libraries(resolve) {
	  return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(623)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var librariesLibrary = function librariesLibrary(resolve) {
	  return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var librariesFilm = function librariesFilm(resolve) {
	  return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(625)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var employees = function employees(resolve) {
	  return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(609)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var admin = function admin(resolve) {
	  return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(607)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adminAddEdit = function adminAddEdit(resolve) {
	  return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(608)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var routes = [{
	  path: '/',
	  redirect: function redirect() {
	    if (_auth2.default.authenticated) {
	      return {
	        path: '/accounts'
	      };
	    }
	    return {
	      path: '/login'
	    };
	  }
	}, {
	  path: '/accounts',
	  component: accounts,
	  beforeEnter: _auth2.default.requireAuth
	}, {
	  path: '/accounts/add',
	  name: 'accountsAdd',
	  component: accountsAdd,
	  beforeEnter: _auth2.default.requireAuth
	}, {
	  path: '/accounts/:id',
	  component: accountsView,
	  beforeEnter: _auth2.default.requireAuth,
	  children: [{
	    path: 'subscriptions',
	    name: 'accountsViewSubscriptions',
	    component: accountsViewSubscriptions
	  }, {
	    path: 'subscriptions/add',
	    name: 'accountsViewSubscriptionsAdd',
	    component: accountsViewSubscriptionsEdit
	  }, {
	    path: 'subscriptions/:sub',
	    name: 'accountsViewSubscriptionsEdit',
	    component: accountsViewSubscriptionsEdit
	  }, {
	    path: 'devices',
	    name: 'accountsViewDevices',
	    component: accountsViewDevices
	  }, {
	    path: 'statistics',
	    name: 'accountsViewStatistics',
	    component: accountsViewStatistics
	  }, {
	    path: 'agreements',
	    name: 'accountsViewAgreements',
	    component: accountsViewAgreements
	  }, {
	    path: 'changes',
	    name: 'accountsViewChanges',
	    component: accountsViewChanges
	  }, {
	    path: 'history',
	    name: 'accountsViewHistory',
	    component: accountsViewHistory
	  }, {
	    path: 'settings',
	    name: 'accountsViewSettings',
	    component: accountsViewSettings
	  }, {
	    path: 'information',
	    name: 'accountsViewInformation',
	    component: accountsViewInformation
	  }]
	}, {
	  path: '/prospects',
	  component: prospects,
	  beforeEnter: _auth2.default.requireAuth
	}, {
	  path: '/prospects/add',
	  component: prospectsAdd,
	  beforeEnter: _auth2.default.requireAuth
	}, {
	  path: '/website',
	  component: website,
	  beforeEnter: _auth2.default.requireAuth,
	  children: [{
	    path: '',
	    name: 'websiteArticleList',
	    component: websiteArticleList
	  }, {
	    path: 'article/:id',
	    name: 'websiteArticle',
	    component: websiteArticle
	  }, {
	    path: 'contentEdit',
	    name: 'websiteContentEdit',
	    component: websiteContentEdit
	  }, {
	    path: 'file',
	    name: 'languageFileEdit',
	    component: websiteLanguageFile
	  }, {
	    path: 'logotype',
	    name: 'websiteLogoSort',
	    component: websiteLogoSort
	  }]
	}, {
	  path: '/libraries',
	  component: libraries,
	  beforeEnter: _auth2.default.requireAuth
	}, {
	  path: '/libraries/category/:id',
	  component: librariesLibrary,
	  beforeEnter: _auth2.default.requireAuth
	}, {
	  path: '/libraries/film/:id',
	  component: librariesFilm,
	  beforeEnter: _auth2.default.requireAuth
	}, {
	  path: '/employees',
	  component: employees,
	  beforeEnter: _auth2.default.requireAuth
	}, {
	  path: '/password',
	  component: password,
	  beforeEnter: _auth2.default.afterAuth
	}, {
	  path: '/reset/:id',
	  component: reset,
	  beforeEnter: _auth2.default.afterAuth
	}, {
	  path: '/login',
	  component: login,
	  beforeEnter: _auth2.default.afterAuth
	}, {
	  path: '/admin',
	  component: admin,
	  beforeEnter: _auth2.default.requireAdminAuth
	}, {
	  path: '/admin/add',
	  component: adminAddEdit,
	  beforeEnter: _auth2.default.requireAdminAuth
	}, {
	  path: '/admin/:id',
	  name: 'adminEdit',
	  component: adminAddEdit,
	  beforeEnter: _auth2.default.requireAdminAuth
	}, {
	  path: '*',
	  redirect: {
	    path: '/'
	  }
	}];
	
	var router = exports.router = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes
	});

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _loader = __webpack_require__(158);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _header = __webpack_require__(642);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _menu = __webpack_require__(644);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      loaderActive: true,
	      authenticated: false
	    };
	  },
	  mounted: function mounted() {
	    var that = this;
	
	    that.loaderActive = false;
	    that.authenticated = _auth2.default.authenticated;
	  },
	  created: function created() {
	    var that = this;
	
	    _auth2.default.$on('force-logout', function () {
	      that.$router.go('/login');
	      that.authenticated = false;
	      window.location.reload();
	    });
	
	    _auth2.default.$on('login-successful', function () {
	      that.authenticated = true;
	    });
	  },
	
	  components: {
	    loader: _loader2.default,
	    medfilmHeader: _header2.default,
	    medfilmMenu: _menu2.default
	  }
	};

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _profile = __webpack_require__(643);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['authenticated'],
	  components: {
	    userProfile: _profile2.default
	  }
	};

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(160);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _velocityAnimate = __webpack_require__(9);
	
	var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
	
	var _sizzle = __webpack_require__(243);
	
	var _sizzle2 = _interopRequireDefault(_sizzle);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['authenticated'],
	  data: function data() {
	    return {
	      user: {
	        id: null,
	        name: null,
	        email: null,
	        permissions: {
	          admin: 0
	        }
	      }
	    };
	  },
	
	  methods: {
	    show: function show() {
	      (0, _velocityAnimate2.default)(this.$el, 'fadeIn', { duration: 50 });
	    },
	    showAdmin: function showAdmin() {
	      (0, _velocityAnimate2.default)((0, _sizzle2.default)(this.$el, '.admin'), 'fadeIn', { duration: 50 });
	    },
	    hide: function hide() {
	      (0, _velocityAnimate2.default)(this.$el, 'fadeOut', { duration: 50 });
	    },
	    logout: function logout() {
	      _auth2.default.logout();
	    }
	  },
	  watch: {
	    'authenticated': {
	      handler: function handler(value) {
	        if (value) {
	          (0, _assign2.default)(this.user, _auth2.default.user);
	          this.show();
	          return;
	        }
	
	        this.hide();
	      }
	    }
	  }
	};

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _velocityAnimate = __webpack_require__(9);
	
	var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['loaderActive'],
	    watch: {
	        loaderActive: {
	            handler: function handler() {
	                if (this.loaderActive === false) {
	                    (0, _velocityAnimate2.default)(this.$el, 'fadeOut', { duration: 300 });
	                }
	
	                if (this.loaderActive === true) {
	                    (0, _velocityAnimate2.default)(this.$el, 'fadeIn', { duration: 300 });
	                }
	            },
	
	            deep: true
	        }
	    }
	};

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sizzle = __webpack_require__(243);
	
	var _sizzle2 = _interopRequireDefault(_sizzle);
	
	var _velocityAnimate = __webpack_require__(9);
	
	var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['authenticated'],
	  mounted: function mounted() {
	    this.checkLogin();
	  },
	
	  methods: {
	    checkLogin: function checkLogin() {
	      if (this.authenticated) {
	        this.showMenu();
	      } else {
	        this.hideMenu();
	      }
	    },
	    hideMenu: function hideMenu() {
	      (0, _velocityAnimate2.default)((0, _sizzle2.default)('ul', this.$el), 'fadeOut', { duration: 50 });
	    },
	    showMenu: function showMenu() {
	      (0, _velocityAnimate2.default)((0, _sizzle2.default)('ul', this.$el), 'fadeIn', { duration: 50 });
	    }
	  },
	  watch: {
	    authenticated: {
	      handler: function handler() {
	        this.checkLogin();
	      }
	    }
	  }
	};

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/medfilm-logo.df36542.svg";

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(581)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(390),
	  /* template */
	  __webpack_require__(694),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(561)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(439),
	  /* template */
	  __webpack_require__(674),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5188bc5f",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(555)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(440),
	  /* template */
	  __webpack_require__(668),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-46a2220e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(556)
	}
	var Component = __webpack_require__(3)(
	  /* script */
	  __webpack_require__(442),
	  /* template */
	  __webpack_require__(669),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4ad9469e",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrap"
	  }, [_c('div', {
	    staticClass: "loader"
	  }, [_c('div', {
	    staticClass: "rect1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rect2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rect3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rect4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "rect5"
	  })])])
	}]}

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "profileBox"
	  }, [_c('div', {
	    staticClass: "smallFont"
	  }, [_vm._v("Logged in as")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  }, [(_vm.user.permissions.admin > 0) ? _c('router-link', {
	    staticClass: "profile-button admin",
	    attrs: {
	      "to": "/admin"
	    }
	  }, [_vm._v("Admin Panel")]) : _vm._e(), _vm._v(" "), (_vm.user.permissions.admin > 0) ? _c('p', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "profile-button",
	    on: {
	      "click": function($event) {
	        return _vm.logout()
	      }
	    }
	  }, [_vm._v("Log out")])], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', [_c('div', {
	    staticClass: "container"
	  }, [_c('menu', [_c('ul', [_c('li', [_c('router-link', {
	    staticClass: "button-wrap",
	    attrs: {
	      "tag": "div",
	      "to": "/accounts"
	    }
	  }, [_c('a', [_vm._v("Accounts")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "button-wrap",
	    attrs: {
	      "tag": "div",
	      "to": "/prospects"
	    }
	  }, [_c('a', [_vm._v("Prospects")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "button-wrap",
	    attrs: {
	      "tag": "div",
	      "to": "/website"
	    }
	  }, [_c('a', [_vm._v("Website")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "button-wrap",
	    attrs: {
	      "tag": "div",
	      "to": "/libraries"
	    }
	  }, [_c('a', [_vm._v("Film Database")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    staticClass: "button-wrap",
	    attrs: {
	      "tag": "div",
	      "to": "/employees"
	    }
	  }, [_c('a', [_vm._v("Employees")])])], 1)])])]), _vm._v(" "), _c('div', {
	    staticClass: "bar"
	  })])
	},staticRenderFns: []}

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('div', {
	    staticClass: "container"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(593),
	      "height": "50"
	    }
	  }), _vm._v(" "), _c('user-profile', {
	    attrs: {
	      "authenticated": _vm.authenticated
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('medfilm-header', {
	    attrs: {
	      "authenticated": _vm.authenticated
	    }
	  }), _vm._v(" "), _c('medfilm-menu', {
	    attrs: {
	      "authenticated": _vm.authenticated
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "wrap"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('router-view', {
	    attrs: {
	      "authenticated": _vm.authenticated
	    }
	  })], 1)]), _vm._v(" "), _c('loader', {
	    attrs: {
	      "loaderActive": _vm.loaderActive
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "auth"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// js/app.cb015ba131b7b7680447.js